import { Alert } from "@material-ui/lab";

type SrAlertProps = {
  children: React.ReactNode;
};

const SrAlert = ({ children, ...props }: SrAlertProps) => {
  return (
    <Alert variant="filled" {...props}>
      {children}
    </Alert>
  );
};

export default SrAlert;
